import React, { useRef, useEffect } from 'react'
import { brandCSS } from '../../brand'
import { POST_CSS } from './post.css.js'
import Breadcrumb, { BREADCRUMB_CSS } from '../components/Breadcrumb'
import ReadingProgress from './ReadingProgress'
import Hero from './Hero'
import TableOfContents from './TableOfContents'
import RelatedPosts from './RelatedPosts'
import BookingSearchForm from '../components/BookingSearchForm.jsx'

export default function SinglePost({ data }) {
  useEffect(() => {
    const root = document.getElementById('app-root')
    if (root) root.style.visibility = 'visible'
  }, [])
  
  const post       = data?.post ?? {}
  const contentRef = useRef(null)

  return (
    <>
      <style>{brandCSS + BREADCRUMB_CSS + POST_CSS}</style>
      <ReadingProgress />

      <div className="sp-page">
        <Hero post={post} />
        <BookingSearchForm />

        <div className="sp-breadcrumb-bar">
          <Breadcrumb items={post.breadcrumbs ?? []} />
        </div>

        <div className="sp-layout">
          <article className="sp-article">
            <div
              ref={contentRef}
              className="sp-content"
              dangerouslySetInnerHTML={{ __html: post.content ?? '' }}
            />
          </article>

          <aside className="sp-sidebar">
            <div className="sp-sidebar__sticky">
              <TableOfContents contentRef={contentRef} />
              <div className="sp-sidebar__rule" />
              <div className="sp-sidebar__back">
                {post.breadcrumbs?.[1]?.url && (
                  <a href={post.breadcrumbs[1].url} className="sp-back-link">
                    ← Back to {post.breadcrumbs[1].label}
                  </a>
                )}
              </div>
            </div>
          </aside>
        </div>

        <div className="sp-related-wrap">
          <RelatedPosts posts={data?.relatedPosts} category={post.category} />
        </div>
      </div>
    </>
  )
}
